import _ from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { overviewClientOpps, getCustomerTable, getClientOpportunity } from '../../../../Services/clientService';
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import { Accordion, AccordionTab } from 'primereact/accordion';
import RadioElement from "../../../../Components/UiComponents/RadioElement";
import Loader from '../../../../Components/UiComponents/Loader';
import ToastElement from '../../../../Components/UiComponents/ToastElement';
import PlaylistVideos from '../../../../Components/Videos/PlaylistVideos';
import { Dialog } from 'primereact/dialog';
export default function Project(props) {
    const [clientOverview, setClientOverviewData] = useState(null);
    const [customerTable, setCustomerTable] = useState(null);
    const [clientOpportunityData, setClientOpportunity] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [newModule, setNewModule] = useState({});
    const [loading, setLoading] = useState(false);
    const [showVideo, setShowVideo] = useState(false);
    const toastRef = useRef();

    useEffect(() => {
        if (props.projectData.clientSectionsProject) {
            let obj1 = _.find(props.projectData.clientSectionsProject, { section_name: "Overview of Client Plan" })?.display_name;
            let obj2 = _.find(props.projectData.clientSectionsProject, { section_name: "Our Client Service Team" })?.display_name;
            let obj3 = _.find(props.projectData.clientSectionsProject, { section_name: "Contract" })?.display_name;

            let combined = { obj1, obj2, obj3 };
            setNewModule(combined)
        }
    }, [props.projectData.clientSectionsProject])

    useEffect(() => {
        getClientOverview();
        getCustomerTableInfo();
    }, [props.customerId]);

    useEffect(() => {
        clientOpportunity();
    }, []);


    const clientOpportunity = async () => {
        setLoading(true); 
        try {
                if (props.customerId) {
                // Fetch client opportunity data
                const res = await getClientOpportunity(props.clientId, props.customerId);
                if(res && res.data){
                    setClientOpportunity(res);
                }
                }
            } catch (error) {
                // Handle any errors during the API request
                toastRef.current.showToast({
                    type: "error",
                    message: "Failed to fetch client opportunity. Please try again or contact Admin."
                });
            } finally {
                setLoading(false); 
            }
        
    };
    
 

    const getClientOverview = async () => {
        try {
          if (props.customerId) {
            setLoading(true);
            
            // Make the API call to get the client overview
            const res = await overviewClientOpps(props.clientId, props.customerId, 'client');
            
            // Handle success response
            if (res && res.data) {
              setClientOverviewData(res.data);
              toastRef.current.showToast({
                type: "success",
                message: "Client overview data loaded successfully."
              });
            } else {
              toastRef.current.showToast({
                type: "error",
                message: "No data found for the client overview."
              });
            }
          }
        } catch (error) {
          // Catch any error during the API call and notify the user
          toastRef.current?.showToast({
            type: "error",
            message: "Failed to load client overview. Please try again or contact Admin."
          });
        } finally {
          setLoading(false);
        }
      };
      


    
    const getCustomerTableInfo = async () => {
        setLoading(true); 
        try {
                if (props.customerId) {
                const res = await getCustomerTable(props.customerId);
                if(res && res.data){
                    setCustomerTable(res.data); 
                }
            }
            } catch (error) {
                // Handle errors during the API request
                toastRef.current.showToast({
                    type: "error",
                    message: "Failed to fetch customer table information. Please try again or contact Admin.",
                });
            } finally {
                setLoading(false);
            }
    };
    
    const OpportunityDisplay = ({ clientOpportunityData }) => {
        const handleLeftClick = () => {
            setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : clientOpportunityData.data.length - 1));
        };

        const handleRightClick = () => {
            setCurrentIndex((prevIndex) => (prevIndex < clientOpportunityData.data.length - 1 ? prevIndex + 1 : 0));
        };

        return (
            <div className="form-group row align-items-center mb-0 mt-20">
                <div className="col-md-4 pl-0 pt-17">
                    <p className="sub-label-text">
                        {clientOpportunityData?.data[currentIndex]?.opportunity_name}
                    </p>
                </div>
                <div className="col pr-0 d-flex justify-end">
                    <ButtonElement className="edit-option-button" type="button" icon="pi pi-chevron-left" onClick={handleLeftClick} />
                    <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-chevron-right" onClick={handleRightClick} />
                </div>
            </div>
        );

    };

    const handleButtonClick = () => {
        setShowVideo(true);
      };
    
      const closeVideo = () => {
          setShowVideo(false);
      };


    return (
        <div className='new-field'>
            <Loader loading={loading} />
            <ToastElement ref={toastRef} />
            {/* <div className='d-flex'> */}
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <p className="label-text">
                            {_.find(props.projectData.clientSectionsProject, { section_name: "List of Client Projects" })?.display_name}
                        </p>
                         <ButtonElement className="upload-button " type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
                    </div>
                    {
                        _.find(customerTable?.cust[0].modules, { ESG_module_name: "Stakeholders" })
                            ?.sub_modules.find(sub_module => sub_module.sub_module_name === "Project")
                            ?.tables[0].status &&
                        <div className="box-border">
                            <div className="form-group row align-items-center mb-0">
                                <div className="col-md-6 pl-0">
                                    <p className="label-text">
                                        {_.find(customerTable?.cust[0].modules, { ESG_module_name: "Stakeholders" })
                                            ?.sub_modules.find(sub_module => sub_module.sub_module_name === "Project")
                                            ?.tables[0].display_name}
                                    </p>
                                </div>
                            </div>
                            <div>
                                {clientOpportunityData?.data?.map((opportunity, index) => (
                                    <li key={index} className='mar-t-8'>
                                        <a className="form-label-text text-left mr-20 pointer" onClick={(e) => setCurrentIndex(index)}>{opportunity.opportunity_name}</a>
                                    </li>
                                ))}
                            </div>
                        </div>
                    }
                </div>
                <div className="mt-20">
                    <p className="label-text">
                        {_.find(props.projectData.clientSectionsProject, { section_name: "Overview of Client Projects" })?.display_name}
                    </p>
                    {
                        _.find(props.projectData.clientFieldsProject, { field_name: "Active Bids" })?.field_status &&
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">{props.projectData.clientFieldsProject[0]?.display_name}:</label>
                            </div>
                            <div className='col pr-0'>
                                <label className="form-label text-left">{clientOverview?.active_bids}</label>
                            </div>
                        </div>
                    }
                    {
                        _.find(props.projectData.clientFieldsProject, { field_name: "Inactive Bids" })?.field_status &&
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">{props.projectData.clientFieldsProject[1]?.display_name}:</label>
                            </div>
                            <div className='col pr-0'>
                                <label className="form-label text-left">{clientOverview?.inactive_bids}</label>
                            </div>
                        </div>
                    }
                    {
                        _.find(props.projectData.clientFieldsProject, { field_name: "Stopped Bids" })?.field_status &&
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">{props.projectData.clientFieldsProject[2]?.display_name}:</label>
                            </div>
                            <div className='col pr-0'>
                                <label className="form-label text-left">{clientOverview?.stopped_bids}</label>
                            </div>
                        </div>
                    }
                    {
                        _.find(props.projectData.clientFieldsProject, { field_name: "Won Bids" })?.field_status &&
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">{props.projectData.clientFieldsProject[3]?.display_name}:</label>
                            </div>
                            <div className='col pr-0'>
                                <label className="form-label text-left">{clientOverview?.won_bids}</label>
                            </div>
                        </div>
                    }
                    {
                        _.find(props.projectData.clientFieldsProject, { field_name: "Lost Bids" })?.field_status &&
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">{props.projectData.clientFieldsProject[4]?.display_name}:</label>
                            </div>
                            <div className='col pr-0'>
                                <label className="form-label text-left">{clientOverview?.lost_bids}</label>
                            </div>
                        </div>
                    }
                    {
                        _.find(props.projectData.clientFieldsProject, { field_name: "Value Bids" })?.field_status &&
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">{props.projectData.clientFieldsProject[5]?.display_name}:</label>
                            </div>
                            <div className='col pr-0'>
                                <label className="form-label text-left">{props.customerDetails?.data?.currency + ' ' + clientOverview?.won_value}</label>
                            </div>
                        </div>
                    }
                    {
                        _.find(props.projectData.clientFieldsProject, { field_name: "Total Value" })?.field_status &&
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">{props.projectData.clientFieldsProject[6]?.display_name}:</label>
                            </div>
                            <div className='col pr-0'>
                                <label className="form-label text-left">{props.customerDetails?.data?.currency + ' ' + clientOverview?.total_value}</label>
                            </div>
                        </div>
                    }
                    {
                        _.find(props.projectData.clientFieldsProject, { field_name: "% Of Total Value Won" })?.field_status &&
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">{props.projectData.clientFieldsProject[7]?.display_name}:</label>
                            </div>
                            <div className='col pr-0'>
                                <label className="form-label text-left">{clientOverview?.per_of_tot_val_won} %</label>
                            </div>
                        </div>
                    }
                </div>
            {/* </div> */}
            {
                clientOpportunityData?.data.length > 0 && <OpportunityDisplay clientOpportunityData={clientOpportunityData} currentIndex={setCurrentIndex} />
            }

            {
                clientOpportunityData?.data.length > 0 && Object.entries(newModule).map(([key, value]) => (
                    <div key={key} className='mt-10'>
                        <Accordion activeIndex={0}>
                            {
                                <AccordionTab header={value} disabled>
                                    {
                                        key == 'obj1' &&
                                        <div className="new-field d-flex">
                                            <div className='col-md-6 pl-0'>
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Project ID' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-5 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsSummary, { field_name: 'Project ID' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left">{clientOpportunityData?.data[currentIndex]?.opportunity_seq}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Project Number' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-5 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsSummary, { field_name: 'Project Number' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left">{clientOpportunityData?.data[currentIndex]?.project_number}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.projectFieldsNew, { field_name: 'Project Name' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-5 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsNew, { field_name: 'Project Name' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left">{clientOpportunityData?.data[currentIndex]?.opportunity_name}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.projectFieldsNew, { field_name: 'Project Alias' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-5 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsNew, { field_name: 'Project Alias' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left">{clientOpportunityData?.data[currentIndex]?.opportunity_alias}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Project Description' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-5 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsSummary, { field_name: 'Project Description' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left">{clientOpportunityData?.data[currentIndex]?.summary?.opportunity_description}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.projectFieldsNew, { field_name: 'Type' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-5 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsNew, { field_name: 'Type' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left">{clientOpportunityData?.data[currentIndex]?.opportunity_type}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.commonFields, { field_name: 'Services' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-5 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.commonFields, { field_name: 'Services' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left">{clientOpportunityData?.data[currentIndex]?.services}</label>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <div className='col-md-6 pl-0'>
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Work Type' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-5 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsSummary, { field_name: 'Work Type' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left">{clientOpportunityData?.data[currentIndex]?.summary?.work_type}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Form of Contract' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-5 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsSummary, { field_name: 'Form of Contract' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left">{clientOpportunityData?.data[currentIndex]?.summary?.form_of_contract}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Procurement Route' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-5 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsSummary, { field_name: 'Procurement Route' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left">{clientOpportunityData?.data[currentIndex]?.summary?.procurement_route}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.commonFields, { field_name: 'Sector' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-5 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.commonFields, { field_name: 'Sector' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left">{clientOpportunityData?.data[currentIndex]?.sector}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Project Alert Flag' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-5 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsSummary, { field_name: 'Project Alert Flag' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <RadioElement
                                                                id="opportunity_alert"
                                                                options={[{ key: 'yes', name: "Yes" }, { key: 'no', name: "No" }]}
                                                                value={clientOpportunityData?.data[currentIndex]?.project_alert_flag?.radio}
                                                                className="radio-group-class" // Add any additional classes if necessary
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                    {
                                        key == 'obj2' &&
                                        <div className="new-field d-flex">
                                            <div className='col-md-6 pl-0'>
                                                {
                                                    _.find(props.projectData.projectFieldsNew, { field_name: 'Bid Leader' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-5 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsNew, { field_name: 'Bid Leader' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left">{clientOpportunityData?.data[currentIndex]?.bid_Leader}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.commonFields, { field_name: 'Business Unit' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-5 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.commonFields, { field_name: 'Business Unit' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left">{clientOpportunityData?.data[currentIndex]?.business_unit}</label>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <div className='col-md-6 pl-0'>
                                                <div className="box-border">
                                                    <div className="form-group row align-items-center mb-0">
                                                        <div className="col-md-6 pl-0">
                                                            <p className="label-text">
                                                                {_.find(customerTable?.cust[0].modules, { ESG_module_name: "Stakeholders" })
                                                                    ?.sub_modules.find(sub_module => sub_module.sub_module_name === "Project")
                                                                    ?.tables[1].display_name}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className='w-50'>
                                                        {
                                                            clientOpportunityData?.data[currentIndex]?.ie_bid_team?.internal_bid_team.map((teamMember, memberIndex) => (
                                                                <li>
                                                                    <label className="form-label text-left" key={memberIndex}>{teamMember.team_member}</label>
                                                                </li>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {
                                        key == 'obj3' &&
                                        <div className="new-field d-flex">
                                            <div className='col-md-6 pl-0'>
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Tender Due Out' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-4 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsSummary, { field_name: 'Tender Due Out' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0 d-flex'>
                                                            <RadioElement
                                                                id="tender_due_date"
                                                                options={[{ key: 'Est', name: "Est" }, { key: 'Act', name: "Act" }]}
                                                                value={clientOpportunityData?.data[currentIndex]?.tender_due?.radio}
                                                                className="radio-group-class" // Add any additional classes if necessary
                                                                disabled
                                                            />
                                                            <label className="form-label text-left ml-20">{clientOpportunityData?.data[currentIndex]?.tender_due?.text}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Award Date' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-4 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsSummary, { field_name: 'Award Date' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0 d-flex'>
                                                            <RadioElement
                                                                id="summary_grp"
                                                                options={[{ key: 'Est', name: "Est" }, { key: 'Act', name: "Act" }]}
                                                                value={clientOpportunityData?.data[currentIndex]?.summary?.award_date?.radio}
                                                                className="radio-group-class" // Add any additional classes if necessary
                                                                disabled
                                                            />
                                                            <label className="form-label text-left ml-20">{clientOpportunityData?.data[currentIndex]?.summary?.award_date?.text}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Project Start Date' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-4 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsSummary, { field_name: 'Project Start Date' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0 d-flex'>
                                                            <RadioElement
                                                                id="start_date"
                                                                options={[{ key: 'Est', name: "Est" }, { key: 'Act', name: "Act" }]}
                                                                value={clientOpportunityData?.data[currentIndex]?.summary?.contract_start_date_summary?.radio}
                                                                className="radio-group-class" // Add any additional classes if necessary
                                                                disabled
                                                            />
                                                            <label className="form-label text-left ml-20">{clientOpportunityData?.data[currentIndex]?.summary?.contract_start_date_summary?.text}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Project End Date' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-4 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsSummary, { field_name: 'Project End Date' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0 d-flex'>
                                                            <RadioElement
                                                                id="end_date"
                                                                options={[{ key: 'Est', name: "Est" }, { key: 'Act', name: "Act" }]}
                                                                value={clientOpportunityData?.data[currentIndex]?.summary?.contract_end_date_summary?.radio}
                                                                className="radio-group-class" // Add any additional classes if necessary
                                                                disabled
                                                            />
                                                            <label className="form-label text-left ml-20">{clientOpportunityData?.data[currentIndex]?.summary?.contract_end_date_summary?.text}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Project Value' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-4 pl-0">
                                                            <label className="form-label text-left">{(_.find(props.projectData.projectFieldsSummary, { field_name: 'Project Value' })?.display_name) + ' (' + props.customerDetails.data.currency + ')'}:</label>
                                                        </div>
                                                        <div className='col pr-0 d-flex'>
                                                            <RadioElement
                                                                id="project_value"
                                                                options={[{ key: 'Est', name: "Est" }, { key: 'Act', name: "Act" }]}
                                                                value={clientOpportunityData?.data[currentIndex]?.project_value_contract?.radio}
                                                                className="radio-group-class" // Add any additional classes if necessary
                                                                disabled
                                                            />
                                                            <label className="form-label text-left ml-20">{clientOpportunityData?.data[currentIndex]?.project_value_contract?.text}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Contract Value' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-4 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsSummary, { field_name: 'Contract Value' })?.display_name + ' (' + props.customerDetails.data.currency + ')'}:</label>
                                                        </div>
                                                        <div className='col pr-0 d-flex'>
                                                            <RadioElement
                                                                id="contract_value"
                                                                options={[{ key: 'Est', name: "Est" }, { key: 'Act', name: "Act" }]}
                                                                value={clientOpportunityData?.data[currentIndex]?.contract_value?.radio}
                                                                className="radio-group-class" // Add any additional classes if necessary
                                                                disabled
                                                            />
                                                            <label className="form-label text-left ml-20">{clientOpportunityData?.data[currentIndex]?.contract_value?.text | clientOpportunityData?.data[currentIndex]?.contract_value?.number}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Contract Variation' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-4 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsSummary, { field_name: 'Contract Variation' })?.display_name + ' (' + props.customerDetails?.data?.currency + ')'}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left ml-20">{clientOpportunityData?.data[currentIndex]?.contract_variation}</label>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <div className='col-md-6 pl-0'>
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Total Contract Value' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-6 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsSummary, { field_name: 'Total Contract Value' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left">{(props.customerDetails?.data?.currency) + ' ' + (clientOpportunityData?.data[currentIndex]?.total_contract_value?.text | clientOpportunityData?.data[currentIndex]?.total_contract_value?.number)}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Margin Expected' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-6 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsSummary, { field_name: 'Margin Expected' })?.display_name} (%):</label>
                                                        </div>
                                                        <div className='col pr-0 d-flex'>
                                                            <RadioElement
                                                                id="margin_exp"
                                                                options={[{ key: 'Est', name: "Est" }, { key: 'Act', name: "Act" }]}
                                                                value={clientOpportunityData?.data[currentIndex]?.summary?.margin_expected?.radio}
                                                                className="radio-group-class" // Add any additional classes if necessary
                                                                disabled
                                                            />
                                                            <label className="form-label text-left ml-20">{clientOpportunityData?.data[currentIndex]?.summary?.margin_expected?.text}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Contract Variation Margin' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-6 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsSummary, { field_name: 'Contract Variation Margin' })?.display_name + ' (' + props.customerDetails?.data?.currency + ')'}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left">{clientOpportunityData?.data[currentIndex]?.summary?.contract_variation_margin}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Total Contract Margin' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-6 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsSummary, { field_name: 'Total Contract Margin' })?.display_name + ' (' + props.customerDetails.data.currency + ')'}:</label>
                                                        </div>
                                                        <div className='col pr-0'>
                                                            <label className="form-label text-left">{props.customerDetails?.data?.currency + ' ' + clientOpportunityData?.data[currentIndex]?.summary?.contract_margin}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.commonFields, { field_name: 'Bid Cost Contribution' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-6 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.commonFields, { field_name: 'Bid Cost Contribution' })?.display_name + ' (' + props.customerDetails?.data?.currency + ')'}:</label>
                                                        </div>
                                                        <div className='col pr-0 d-flex'>
                                                            <RadioElement
                                                                id="bid_cost"
                                                                options={[{ key: 'Est', name: "Est" }, { key: 'Act', name: "Act" }]}
                                                                value={clientOpportunityData?.data[currentIndex]?.bid_cost?.radio}
                                                                className="radio-group-class" // Add any additional classes if necessary
                                                                disabled
                                                            />
                                                            <label className="form-label text-left ml-20">{clientOpportunityData?.data[currentIndex]?.bid_cost?.text | clientOpportunityData?.data[currentIndex]?.bid_cost?.number}</label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    _.find(props.projectData.projectFieldsSummary, { field_name: 'Other Revenue' })?.field_status === true &&
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-6 pl-0">
                                                            <label className="form-label text-left">{_.find(props.projectData.projectFieldsSummary, { field_name: 'Other Revenue' })?.display_name}:</label>
                                                        </div>
                                                        <div className='col pr-0 d-flex'>
                                                            <RadioElement
                                                                id="other_revenue"
                                                                options={[{ key: 'Est', name: "Est" }, { key: 'Act', name: "Act" }]}
                                                                value={clientOpportunityData?.data[currentIndex]?.other_revenue?.radio}
                                                                className="radio-group-class" // Add any additional classes if necessary
                                                                disabled
                                                            />
                                                            <label className="form-label text-left ml-20">{clientOpportunityData?.data[currentIndex]?.other_revenue?.text}</label>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </AccordionTab>
                            }
                        </Accordion>
                    </div>
                ))
            }
            <Dialog id="videoModal" visible={showVideo}
                breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                }}
                modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
            >
                <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_STAKEHOLDERS_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="stakeholders_associated_projects" />
                    </div>
                </div>
            </Dialog>
        </div>
    );
}
